import React from "react";
import "./css/Divisions.css";

const DIVISIONS = [
  {
    id: "app-development",
    name: "App Development",
    tagline: "Custom applications built for the modern world",
    desc: "We build scalable, user-focused web and mobile applications from concept to deployment using modern cloud technologies.",
    accent: "#4169e1",
    glow: "65, 105, 225",
    services: ["Web Apps", "Mobile Apps", "APIs", "Cloud Infrastructure"],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3">
        <rect x="2" y="3" width="20" height="14" rx="2"/>
        <line x1="8" y1="21" x2="16" y2="21"/>
        <line x1="12" y1="17" x2="12" y2="21"/>
        <polyline points="9 9 12 6 15 9" strokeLinejoin="round"/>
        <line x1="12" y1="6" x2="12" y2="14"/>
      </svg>
    ),
  },
  {
    id: "music-entertainment",
    name: "Music & Entertainment",
    tagline: "Record label, production & digital distribution",
    desc: "From artist development and studio recording to worldwide digital distribution, we handle every part of your music career.",
    accent: "#ff1493",
    glow: "255, 20, 147",
    services: ["Artist Development", "Production", "Distribution", "Live Events"],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3">
        <path d="M9 18V5l12-2v13"/>
        <circle cx="6" cy="18" r="3"/>
        <circle cx="18" cy="16" r="3"/>
      </svg>
    ),
  },
  {
    id: "branding",
    name: "Branding",
    tagline: "Brand building, marketing & advertising",
    desc: "Strategic brand identity, performance advertising, and creative content that makes your business impossible to ignore.",
    accent: "#8a2be2",
    glow: "138, 43, 226",
    services: ["Brand Identity", "Digital Ads", "Social Media", "Content Creation"],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3">
        <path d="M12 2L2 7l10 5 10-5-10-5z"/>
        <path d="M2 17l10 5 10-5"/>
        <path d="M2 12l10 5 10-5"/>
      </svg>
    ),
  },
  {
    id: "news-media",
    name: "News & Media Agency",
    tagline: "Digital news & media for the connected world",
    desc: "Timely, accurate journalism and multimedia storytelling across technology, entertainment, and culture for a global audience.",
    accent: "#ff69b4",
    glow: "255, 105, 180",
    services: ["Journalism", "Podcasts", "Documentaries", "Press Distribution"],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3">
        <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"/>
        <path d="M18 14h-8"/><path d="M15 18h-5"/>
        <path d="M10 6h8v4h-8V6Z"/>
      </svg>
    ),
  },
];

const Divisions = ({ onNavigate }) => (
  <div className="div-page">

    <section className="div-hero">
      <div className="div-hero-inner">
        <p className="div-eyebrow">Our Divisions</p>
        <h1>Four Pillars,<br/>One Vision</h1>
        <p className="div-sub">
          Vyral Media Group operates across four specialised divisions, each focused on a different dimension of the modern media and technology landscape.
        </p>
      </div>
    </section>

    <div className="div-body">
      <div className="div-grid">
        {DIVISIONS.map((d, i) => (
          <button
            key={d.id}
            className="div-card"
            style={{ "--accent": d.accent, "--glow": d.glow }}
            onClick={() => onNavigate("divisionShowcase", d.id)}
          >
            <div className="div-card-top">
              <div className="div-card-icon">{d.icon}</div>
              <span className="div-card-num">0{i + 1}</span>
            </div>
            <h2>{d.name}</h2>
            <p className="div-card-tagline">{d.tagline}</p>
            <p className="div-card-desc">{d.desc}</p>
            <ul className="div-card-chips">
              {d.services.map(s => <li key={s}>{s}</li>)}
            </ul>
            <span className="div-card-cta">
              Explore Division
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
                <line x1="5" y1="12" x2="19" y2="12"/>
                <polyline points="12 5 19 12 12 19"/>
              </svg>
            </span>
          </button>
        ))}
      </div>
    </div>

  </div>
);

export default Divisions;
